module.exports = __webpack_public_path__ + "static/media/title-az.6d60e77b.svg";